<template>
<!---->
		<div class="six1-table">
			<div class="six1-title">
				<span class="six1-title-left"></span>
				<span class="six1-title-center" @click="curChange({id: 0})">{{category.categoryName}}</span>
				<div class="six1-title-right">
					<ul>
						<li v-for="cat in categories" :class="{'cur': cat.isCur}" :key="'cat'+cat.id">
              <a href="javascript:;" @click="curChange(cat)">{{cat.categoryName}}</a>
            </li>
						<!-- <li><a href="">党的历史</a></li>
						<li><a href="">党的理论</a></li>
						<li><a href="">党建实务</a></li>
						<li><a href="">党建文化/企业文化</a></li>
						<li><a href="">公司战略</a></li>
						<li><a href="">公司制度</a></li> -->
					</ul>
				</div>
				<router-link to="/AllCourse" class="six1-more">全部课程</router-link>
			</div>
			<div class="six1-content" v-loading="loading">
				<ul>
					<li v-for="course in courseList" :key="'HCourse'+course.id">
						<a href="javascript:;" @click="todetail(course)">
							<img v-lazy="course.image" class="content-cover">
							<div class="content-content">
								<div class="content-content-title">{{course.name}}</div>
								<div class="content-content-icon">
									<div class="content-content-icon-left">
										<img src="../../../assets/img/icon-eye.png"><span class="conent-content-icon-left-text">{{course.watch}}</span>
									</div>
									<div class="content-content-icon-right">
										<img src="../../../assets/img/icon-heart.png"><span class="conent-content-icon-left-text">{{course.like}}</span>
									</div>
								</div>
							</div>
						</a>
					</li>
				</ul>
        <div class="noThing" v-show="courseList.length == 0">
          <img src="../../../assets/img/nothing.png" alt="">
          <p>暂无内容</p>
        </div>
			</div>
		</div>
</template>

<script>
import '../../../assets/css/index.css'
import { ApiGetCategoryCourse} from '../../../net/home/index.js'
import {setCookie} from '../../../untils/common.js'
export default {
  name: 'categoryCade',
  data: function () {
    return {
      categoryId: 0,
      categories: [],
      courseList: [],
      loading: false
    }
  },
  props: ['category'],
  computed:{

  },
  methods:{
    getCategoryCourse: function () {
      this.loading = true
      const prames = {
        category: this.categoryId,
        pageNum: 1,
        pageSize: 4,
        platform: 'pc'
      }
      ApiGetCategoryCourse(prames).then(res=>{
        if (res.code == 200) {
          if (this.categories.length == 0){
            this.categories = res.pc.categories.map(item=>{
              return {...item, isCur: false}
            })
          }

          this.courseList = res.pc.page.details
          this.loading = false
        }
      }).catch(err=>{
        this.loading = false
      })
    },
    curChange: function (cat) {
      this.categories = this.categories.map(item=>{
        return {...item, isCur: cat.id == item.id}
      })
      this.categoryId = cat.id
      this.getCategoryCourse()
    },
    todetail: function (item){
      if(!this.$store.state.isLogin){
        this.$store.commit('showLogin', true)
        return
      }
      setCookie('frompage','home');
      this.$router.push({
          path : 'CourseDetail',
          query : {id : item.id},
      })
    }
  },
  mounted: function () {
    this.categoryId = this.$props.category.id
    this.getCategoryCourse()
  }
}
</script>

<style scoped>
.notice-box{
  margin: 30px 0;
}
.noThing{
  width: 100%;
  height: 272px;
  text-align: center;
}
.noThing img{
  width: 200px;
  margin-top: 30px;

}
.noThing p {
  margin-top: 20px;
  font-size: 20px;
}
.six1-title-center{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/children/categoryCade.vue